import { css } from "@emotion/react";
import styled from "@emotion/styled";
import ToggleStar from "../../../../../atoms/inputs/ToggleStar";
import { roundCornersShadowBorder } from "../../../../../../assets/styles/styles";

export const notifCounterCss = css`
  color: white;
  font-size: 90px;
  font-weight: bold;
  line-height: 1;

  @media only screen and (max-width: 1024px) {
    font-size: 60px;
  }
`;

export const labelCss = css`
  font-size: 16px;
  color: white;

  // https://stackoverflow.com/a/65723242/10467064
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;

  @media only screen and (max-width: 1024px) {
    font-size: 10px;
    -webkit-line-clamp: 2;
  }
`;

export const getOuterContainerCss = (bgColor: string) => css`
  ${roundCornersShadowBorder()};
  background-color: ${bgColor};
  color: white;

  width: 180px;
  min-width: 180px;
  height: 180px;
  display: inline-block;
  position: relative;

  @media only screen and (max-width: 1024px) {
    width: 100px;
    min-width: 100px;
    height: 100px;
  }
`;

export const innerContainerCss = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
  height: 100%;
  padding-top: 20px;
  &:hover {
    text-decoration: none;
  }

  @media only screen and (max-width: 1024px) {
    padding-top: 7px;
  }
`;
export const ToggleStarFavourite = styled(ToggleStar)`
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;

  @media only screen and (max-width: 1024px) {
    font-size: 25px;
  }
`;
